<template>
    <div
        class="inline-flex items-center px-2 py-1 space-x-1 rounded-full"
        :class="[`text-${color}-800 bg-${color}-100 dark:bg-${color}-800 dark:text-${color}-100`]"
    >
        <Icon :icon="icon" class="size-3"></Icon>
        <span v-if="props.value" style="font-size: 0.8em">
            {{ lang(`products::products.wizard.types.${props.value}_short`) }}
        </span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { GridComponent } from '@src/Common/Components/types';

const props = withDefaults(defineProps<GridComponent>(), {});
//

const color = computed(() => {
    switch (props.value) {
        case 'simple':
            return 'teal';
        case 'configuration':
            return 'orange';
        case 'copy':
            return 'blue';
        default:
            return 'gray';
    }
});

const icon = computed(() => {
    switch (props.value) {
        case 'simple':
            return 'fa/solid/box';
        case 'configuration':
            return 'fa/solid/box-taped';
        case 'copy':
            return 'fa/solid/boxes-packing';
        default:
            return 'fa/solid/box';
    }
});
</script>
